export const APP_PORT = 4101;
export const APP_RELEASE_VERSION = '2025.12.1.0';
export const APP_API_VERSION = 'v1';
export const APP_BUILD_TIME = '3/3/2026, 5:41:22 PM'; // Do not edit this line
